// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PasswordResetConfirmationController = function ($scope, $routeParams, $location, $http, $rootScope, gettextCatalog, gettext, CheckPasswordStrength, Throttle) {
    $scope.passwordReset = { };
    
    if ($routeParams.language)
        $scope.setLang($routeParams.language);
    else
        $scope.setLang($rootScope.defaultLanguage);

    if ($location.path().indexOf("/passwordTooWeak") !== -1)
        $scope.reason = "too-weak";
    else if ($location.path().indexOf("/passwordChangeRequired") !== -1)
        $scope.reason = "expired";

    let estimationResult = Throttle(CheckPasswordStrength, 1000, function (response) { $scope.estimationResult = response.data; });

    $scope.preview = function () {
        let checkPasswordData = { password: $scope.passwordReset.NewPassword, token: $routeParams.token }
        estimationResult.request(checkPasswordData);
    };

    $scope.save = function () {
        let transform = function (x) {
            return $.param(x);
        };

        if ($scope.passwordReset.NewPassword != $scope.passwordReset.ConfirmPassword) {
            alert(gettextCatalog.getString(gettext("Passwords must match")));
            return;
        }
        
        $http({
            method: "POST",
            url: "/api/v1/passwordReset/" + $routeParams.token,
            data: $scope.passwordReset,
            cache: false
        }).then(function (response) {
            let dto = response.data;
            $scope.passwordReset.EmailAddress = dto.Email;
            $http({//todo: remove duplication
                method: "POST",
                url: baseUrl + "oauth/token",
                params: null,
                data: { "username": $scope.passwordReset.EmailAddress, "password": $scope.passwordReset.NewPassword, "client_id": "51014335eb596a0e149f2b36", "grant_type": "password" },
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                transformRequest: transform,
                cache: false
            }, function (data) {
                $scope.password = null;
                console.log("async1");
                if (data["access_token"]) {
                    console.log("async2");
                    $rootScope.accessToken = data["access_token"];
                    $rootScope.refreshToken = data["refresh_token"];
                    $rootScope.username = $scope.passwordReset.EmailAddress;

                    $http.defaults.headers.common["Authorization"] = "Bearer " + data["access_token"];

                    localStorage.setItem('username', $rootScope.username);
                    localStorage.setItem('access_token', $rootScope.accessToken);
                    localStorage.setItem('refresh_token', $rootScope.refreshToken);
                    localStorage.removeItem('passwordResetRequired');
                    $location.path($rootScope.defaultLocation());
                }
            });
            
            $scope.password = null;
            if (localStorage.getItem('passwordResetRequired') === null)
                $location.path($rootScope.defaultLocation());
        });
    };
};
PasswordResetConfirmationController.$inject = ['$scope', '$routeParams', '$location', '$http', '$rootScope', 'gettextCatalog', 'gettext','CheckPasswordStrength', 'Throttle'];
